import React, { useState } from "react";
import { TextField, MenuItem, useTheme, useMediaQuery, Button } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { useTranslation } from "react-i18next";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PaginationOptionPopup from "./PaginationOptionPopup";
import Select from "react-select";


export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        width: "38px",
        border: "1px solid #0000008a",
        borderColor: "#00000033 !important",
        boxShadow: "none",
        cursor: "pointer",
        input: {
            ...provided.input,
            caretColor: 'transparent',
        },
    }),
    dropdownIndicator: () => ({
        display: "none", // Ẩn con trỏ xuống
    }),
    indicatorSeparator: () => ({
        display: "none", // Ẩn đường ngăn cách
    }),
    option: () => ({
        backgroundColor: "white",
        fontSize: "inherit",
        cursor: "pointer",
        padding: "2px 0",
        color: "#000",
        width: "38px",
        textAlign: "center",
        display: "block",
        "&:hover": {
            backgroundColor: "#1877f214",
        },
    }),
    menu: (provided) => ({
        ...provided,
        marginBottom: 0
    }),
    menuList: (provided) => ({
        ...provided,
        marginBottom: 0
    })
};


export default function GlobitsPagination({
    pageIndex = 1,
    pageSize = 10,
    setPageSize,
    setPageIndex,
    totalPages,
    pageSizeOption = [5, 10, 25, 50,100,200],
    totalElements,
    minisize = false,
    isPaginationTotalElement = true,
    isPaginationPageSize = true,
}) {
    const { t } = useTranslation();

    const handleChangeSize = (event) => {
        setPageSize(Number(event.value))
    };
    const handleChangeIndex = (_, newValue) => setPageIndex(newValue);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [openPopup, setOpenPopup] = useState(false);

    const optionsSize = pageSizeOption.map((item) => ({
        value: item,
        labe: `${item}`
    }))

    const pageSizeValue = {
        value: pageSize,
        labe: `${pageSize}`
    }

    return (
        <section className={`pagination-container ${minisize ? "pagination-container-mini" : ""}`}>
            {!isMobile ? (
                <>
                    {isPaginationTotalElement &&
                        <p className="pagination-total-element">
                            {t('pagination.present')} {(pageIndex - 1) * pageSize + (pageIndex === 1 ? 1 : 0)}-{pageIndex * pageSize} {t('pagination.among')} <b>{totalElements || 0}</b>
                        </p>
                    }
                    {isPaginationPageSize &&
                        <div className="pagination-page-size gap-1">
                            <span>
                                {t("pageSize")}
                            </span>

                            <Select
                                value={pageSizeValue}
                                onChange={handleChangeSize}
                                styles={customStyles}
                                options={optionsSize}
                                menuPlacement="top"
                                getOptionLabel={option => {
                                    return option?.labe
                                }}
                                placeholder=""
                            />
                        </div>
                    }
                </>
            ) : (
                <>
                    <div item className="flex-center gap-2">
                        <p>{totalElements} {t('pagination.record')}</p>
                        <Button className="btn-orange mw-none" onClick={() => setOpenPopup(true)}>
                            <MenuBookIcon fontSize="small" />
                        </Button>
                    </div>

                    <PaginationOptionPopup
                        open={openPopup}
                        handleClose={() => setOpenPopup(false)}
                        totalElements={totalElements}
                        setRowsPerPage={setPageSize}
                        pageSizeOption={pageSizeOption}
                        totalPages={totalPages}
                        handleChangePage={handleChangeIndex}
                        page={pageIndex}
                        pageSize={pageSize}
                    />
                </>
            )}

            <Pagination
                className="pagination-page-index"
                count={totalPages || 1}
                shape="rounded"
                page={pageIndex}
                color="primary"
                onChange={handleChangeIndex}
                boundaryCount={1}
                siblingCount={1}
                showFirstButton
                showLastButton
            />
        </section>
    );
}
